// Data Assure consumption data service
import dataAssureData from './dataAssureConsumption.json';

// Extract data from the JSON file
const { consumptionData, csmMapping } = dataAssureData;

// Get consumption data for a specific tenant
export const getTenantConsumption = (tenantId) => {
  return consumptionData[tenantId] || null;
};

// Get all tenants for a specific CSM
export const getTenantsForCSM = (csmEmail) => {
  return csmMapping[csmEmail] || [];
};

// Get all consumption data
export const getAllConsumptionData = () => {
  return consumptionData;
};

// Get CSM mapping
export const getCSMMapping = () => {
  return csmMapping;
};

// Convert monthly data to chart format
export const getChartDataForTenant = (tenantId) => {
  const tenantData = consumptionData[tenantId];
  if (!tenantData) return null;
  
  // Sort months chronologically
  const months = Object.keys(tenantData.monthlyData).sort();
  
  // Prepare data for chart
  const labels = months.map(month => {
    const [year, monthNum] = month.split('-');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${monthNames[parseInt(monthNum) - 1]} ${year}`;
  });
  
  const failedData = months.map(month => tenantData.monthlyData[month].failed);
  const passedData = months.map(month => tenantData.monthlyData[month].passed);
  const cautionsData = months.map(month => tenantData.monthlyData[month].passedWithCautions);
  
  // Calculate total validations per month
  const totalData = months.map((month, i) => failedData[i] + passedData[i] + cautionsData[i]);
  
  return {
    labels,
    datasets: [
      {
        label: 'Total Validations',
        data: totalData,
        backgroundColor: '#ff6b35',
        borderColor: '#e5602f',
        borderWidth: 2,
        borderRadius: 6
      }
    ],
    totalData,
    tenantInfo: {
      csm: tenantData.csm,
      csmName: tenantData.csmName,
      totalCounts: tenantData.totalCounts
    }
  };
};